import styled from 'styled-components';
import { MdClose } from 'react-icons/md';
import theme from '../../theme';

type PropTypeShowModal = {
  showModal: boolean
}

export const Background = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.3);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// eslint-disable-next-line no-unused-vars
export const ModalWrapper = styled.div.attrs((props: PropTypeShowModal) => ({})) < PropTypeShowModal >`
  width: 500px;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
  background: ${theme.colors.primary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 10;
  border-radius: 10px;

  @media (max-width: 667px) {
    max-width: 350px;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CloseModalButton = styled(MdClose)`
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  padding: 0;
  z-index: 10;
  color: #fff;
`;

export const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 30px;

  label {
    color: #fff;
    font-size: 16px;
  }

  input {
    padding: 15px;
    width: 100%;
    border: none;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #fff;
    background-color: ${theme.colors.cardB3};
  }

  input::placeholder {
    color: #fff;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 45px;
    border-radius: 10px;
    font-size: 14px;
    margin-top: 20px;
    cursor: pointer;
    background: #fff;
    color: ${theme.colors.primary};
    border: none;
    transition: 0.3s;

    &:hover {
      box-shadow: 0 5px 16px rgba(0, 0, 0, 0.5);
    }
  }
`;

export const Logo = styled.img`
  max-height: 150px;
  max-width: 150px;
  margin-bottom: 20px;
  margin-top: 20px;
`;

export const PasswordRecoveryButton = styled.a`
  color: #fff;
  margin-top: 30px;
  margin-bottom: 10px;
  text-align: center;
`;
